import './StopLabel.css'

function StopLabel(props) {
    return (
        <div className='StopLabel'>
            <div>{props.name}</div>
        </div>
    )
}

export default StopLabel
